(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pellegrini-catalog-header-search')) {
    customElements.define('pellegrini-catalog-header-search', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.previewRequest?.abort();
        clearTimeout(this.previewTimer);
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else {
          this.initialize();
        }
      }

      initialize() {
        const form = this.querySelector('form');
        const results = this.querySelector('[data-pg-predictive]');
        const input = form?.elements.namedItem('q');
        if (!this.isConnected || !form || !results || !input || !this.dataset.catalogUrl) return;

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const query = input.value.trim();
          if (query) window.location.assign(this.catalogSearchUrl(query));
        }, { signal: this.controller.signal });

        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.isComposing || event.keyCode === 229) return;
          event.preventDefault();
          if (!event.repeat) form.requestSubmit();
        }, { signal: this.controller.signal });

        input.addEventListener('input', () => {
          if (!input.composing) this.queuePreview(input, results);
        }, { signal: this.controller.signal });
        input.addEventListener('compositionstart', () => {
          input.composing = true;
          clearTimeout(this.previewTimer);
          this.previewRequest?.abort();
        }, { signal: this.controller.signal });
        input.addEventListener('compositionend', () => {
          input.composing = false;
          this.queuePreview(input, results);
        }, { signal: this.controller.signal });
        form.addEventListener('reset', () => {
          clearTimeout(this.previewTimer);
          this.previewRequest?.abort();
          results.querySelector('[slot="results"]').replaceChildren();
          results.removeAttribute('aria-busy');
          this.querySelector('[data-pg-preview-status]').textContent = '';
        }, { signal: this.controller.signal });

        this.observer = new MutationObserver(() => this.updateSearchSuggestions(results));
        this.observer.observe(results, { childList: true, subtree: true });
        this.updateSearchSuggestions(results);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.previewRequest?.abort();
        clearTimeout(this.previewTimer);
        for (const cache of this.catalogIndexes?.values() || []) cache.controller.abort();
        this.catalogIndexes?.clear();
      }

      queuePreview(input, results) {
        clearTimeout(this.previewTimer);
        this.previewRequest?.abort();
        this.previewRequest = null;
        const query = input.value.trim();
        this.querySelector('[data-pg-preview-status]').textContent = '';
        if (!query) {
          results.querySelector('[slot="results"]').replaceChildren();
          results.removeAttribute('aria-busy');
          return;
        }
        results.setAttribute('aria-busy', 'true');
        this.previewTimer = setTimeout(() => this.updatePreview(query, input, results), 200);
      }

      async updatePreview(query, input, results) {
        this.previewRequest?.abort();
        const request = new AbortController();
        this.previewRequest = request;
        const current = () => this.isConnected && !request.signal.aborted && input.value.trim() === query;
        const terms = this.searchText(query).split(/\s+/).filter(Boolean);
        const native = this.nativePreview(query, request.signal).catch(() => null);
        try {
          const products = await this.catalogPreview(query, terms, request.signal);
          const fragment = this.mergePreview(await native, products);
          if (!current()) return;
          results.querySelector('[slot="results"]').replaceChildren(fragment);
          this.updateSearchSuggestions(results);
          this.querySelector('[data-pg-preview-status]').textContent = 'Suchvorschau aktualisiert.';
        } catch (error) {
          const fallback = await native;
          if (!current()) return;
          const destination = new URL(this.catalogSearchUrl(query));
          const filtered = Array.from(destination.searchParams.keys()).some(key => key.startsWith('filter.') || key === 'pg_price_min' || key === 'pg_price_max');
          const useNative = !terms.includes('magnum') && !filtered && fallback?.querySelector('.predictive-search__products product-card');
          const fragment = useNative ? fallback : this.previewMessage('Die Vorschau ist gerade nicht verfügbar. Alle Treffer finden Sie im Sortiment.');
          results.querySelector('[slot="results"]').replaceChildren(fragment);
          this.updateSearchSuggestions(results);
          this.querySelector('[data-pg-preview-status]').textContent = useNative ? 'Suchvorschau aktualisiert.' : 'Die Suchvorschau konnte nicht geladen werden.';
        } finally {
          if (this.previewRequest === request) results.removeAttribute('aria-busy');
        }
      }

      async previewDocument(url, signal) {
        this.previewResponses ||= new Map();
        const key = url.href;
        const cached = this.previewResponses.get(key);
        const parse = html => {
          // Inert templates prevent a fetched collection page from loading its images or scripts.
          const template = document.createElement('template'); template.innerHTML = html; return template.content;
        };
        if (cached && Date.now() - cached.created < 60000) return parse(cached.html);
        const controller = new AbortController();
        const abort = () => controller.abort();
        if (signal.aborted) abort(); else signal.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 12000);
        let html;
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Search preview unavailable: HTTP ${response.status}`);
          html = await response.text();
        } finally {
          clearTimeout(timeout);
          signal.removeEventListener('abort', abort);
        }
        this.previewResponses.delete(key);
        this.previewResponses.set(key, { html, created: Date.now() });
        while (this.previewResponses.size > 20) this.previewResponses.delete(this.previewResponses.keys().next().value);
        return parse(html);
      }

      async nativePreview(query, signal) {
        const url = new URL(this.dataset.searchUrl, window.location.origin);
        let predictive = false;
        try { predictive = Boolean(JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch); } catch (_) { /* Use the standard search endpoint. */ }
        if (predictive) url.pathname = url.pathname.replace(/\/$/, '') + '/suggest';
        url.searchParams.set('q', query);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[limit_scope]', 'each');
        const doc = await this.previewDocument(url, signal);
        const section = doc.querySelector('.shopify-section');
        if (!section) throw new Error('Search preview missing');
        const fragment = document.createDocumentFragment();
        fragment.append(...section.childNodes);
        return fragment;
      }

      previewMessage(message) {
        const fragment = this.querySelector('[data-pg-magnum-preview]').content.cloneNode(true);
        const heading = fragment.querySelector('.predictive-search__category');
        heading.remove();
        const grid = fragment.querySelector('[data-pg-preview-products]');
        const text = document.createElement('p');
        text.className = 'predictive-search__no-results text-lg';
        text.textContent = message;
        grid.replaceWith(text);
        return fragment;
      }

      mergePreview(native, products) {
        const tabs = native?.querySelector('x-tabs');
        if (!tabs) return products;
        const nativePanel = tabs.querySelector('.predictive-search__products')?.closest('[slot="content"]');
        if (nativePanel) {
          const panels = Array.from(tabs.querySelectorAll(':scope > [slot="content"]'));
          tabs.querySelectorAll(':scope > [slot="title"]')[panels.indexOf(nativePanel)]?.remove();
          nativePanel.remove();
        }
        const grid = products.querySelector('[data-pg-preview-products]');
        if (grid) {
          if (native.querySelector('.predictive-search__suggestions')) {
            grid.style.setProperty('--product-list-items-per-row', '4');
            if (grid.children.length > 4) grid.lastElementChild.remove();
          }
          products.querySelector('.predictive-search__category').remove();
          const title = document.createElement('button');
          title.type = 'button'; title.className = 'h6'; title.slot = 'title';
          title.setAttribute('role', 'tab'); title.textContent = this.dataset.previewProductsLabel;
          const panel = document.createElement('div');
          panel.className = 'predictive-search__resource-item'; panel.slot = 'content'; panel.setAttribute('role', 'tabpanel');
          panel.append(products.querySelector('.v-stack'));
          tabs.prepend(title, panel);
        }
        const panels = Array.from(tabs.querySelectorAll(':scope > [slot="content"]'));
        if (!panels.length) return products;
        panels.forEach((panel, index) => { panel.hidden = index !== 0; });
        return native;
      }

      async catalogPreview(query, terms, signal) {
        const destination = new URL(this.catalogSearchUrl(query));
        const base = new URL(destination);
        for (const key of ['q', 'pg_q', 'pg_price_min', 'pg_price_max', 'page', 'section_id', 'sections']) base.searchParams.delete(key);
        base.hash = '';
        base.searchParams.sort();
        const cache = await this.catalogIndex(base);
        if (signal.aborted) throw new DOMException('Preview superseded', 'AbortError');
        const matches = this.searchMatches(cache, terms, this.priceBounds(destination));
        const sort = destination.searchParams.get('sort_by');
        if (sort === 'price-ascending' || sort === 'price-descending') matches.sort((a, b) => (a.p - b.p) * (sort === 'price-descending' ? -1 : 1));
        if (sort === 'title-ascending' || sort === 'title-descending') {
          const collator = new Intl.Collator(document.documentElement.lang || 'de');
          matches.sort((a, b) => collator.compare(a.n, b.n) * (sort === 'title-descending' ? -1 : 1));
        }
        if (!matches.length) return this.previewMessage(this.dataset.previewEmpty.replace('__query__', query));
        const responses = await Promise.allSettled(matches.slice(0, 5).map(item => this.previewCard(item.h, base, cache, signal)));
        if (signal.aborted) throw new DOMException('Preview superseded', 'AbortError');
        const cards = responses.filter(response => response.status === 'fulfilled').map(response => response.value);
        if (!cards.length) throw new Error('Product previews unavailable');
        const fragment = this.querySelector('[data-pg-magnum-preview]').content.cloneNode(true);
        fragment.querySelector('[data-pg-preview-products]').append(...cards);
        return fragment;
      }

      async catalogIndex(base) {
        this.catalogIndexes ||= new Map();
        let cache = this.catalogIndexes.get(base.href);
        if (cache && !cache.promise && Date.now() - cache.created > 60000) {
          cache.controller.abort(); this.catalogIndexes.delete(base.href); cache = null;
        }
        if (!cache) {
          cache = { controller: new AbortController(), cards: new Map(), created: Date.now() };
          this.catalogIndexes.set(base.href, cache);
          cache.promise = this.loadCatalogIndex(base, cache.controller.signal).then(records => {
            cache.records = records; cache.created = Date.now(); return cache;
          }).catch(error => {
            cache.controller.abort();
            if (this.catalogIndexes.get(base.href) === cache) this.catalogIndexes.delete(base.href);
            throw error;
          }).finally(() => { cache.promise = null; });
          while (this.catalogIndexes.size > 3) {
            const oldest = this.catalogIndexes.keys().next().value;
            this.catalogIndexes.get(oldest).controller.abort(); this.catalogIndexes.delete(oldest);
          }
        }
        return cache.promise || cache;
      }

      async wineryNames(base, signal) {
        const url = new URL(base);
        const current = new URL(window.location.href);
        const local = document.querySelector('pellegrini-collection');
        let source = local;
        if (!local || current.pathname.replace(/\/$/, '') !== url.pathname.replace(/\/$/, '')) {
          // Read the existing section mappings once; no second list of manufacturer names to maintain.
          const preview = url.searchParams.get('preview_theme_id') || current.searchParams.get('preview_theme_id');
          url.search = ''; url.hash = '';
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const doc = await this.previewDocument(url, signal);
          source = doc.querySelector('pellegrini-collection');
          if (!source) throw new Error('Collection manufacturer mapping unavailable');
        }
        return new Map(Array.from(source.querySelectorAll('[data-pg-winery]'), entry => [this.searchText(entry.dataset.code).trim(), entry.dataset.name]));
      }

      async loadCatalogIndex(base, signal) {
        const readPage = async page => {
          const url = new URL(base);
          url.searchParams.set('section_id', 'pellegrini-collection-search-index');
          url.searchParams.set('page', String(page));
          const doc = await this.previewDocument(url, signal);
          const element = doc.querySelector('[data-pg-search-index]');
          if (!element) throw new Error('Collection index missing');
          const data = JSON.parse(element.textContent);
          if (data.page !== page || !Array.isArray(data.products) || !Number.isSafeInteger(data.total) || data.total < 0 || data.total > 25000) throw new Error('Invalid collection index');
          return data;
        };
        const [first, wineries] = await Promise.all([readPage(1), this.wineryNames(base, signal)]);
        const batches = [first];
        const pageCount = Math.max(1, Math.ceil(first.total / 250));
        let nextPage = 2;
        const worker = async () => {
          while (nextPage <= pageCount) {
            const page = nextPage++;
            batches[page - 1] = await readPage(page);
          }
        };
        await Promise.all([worker(), worker(), worker()]);
        const records = [], handles = new Set();
        for (let page = 0; page < pageCount; page += 1) {
          const batch = batches[page];
          if (!batch || batch.total !== first.total || Boolean(batch.next) !== (page + 1 < pageCount)) throw new Error('Collection changed during search');
          for (const item of batch.products) {
            if (!item.h || typeof item.n !== 'string' || handles.has(item.h) || !Number.isSafeInteger(item.p)) throw new Error('Invalid search product');
            handles.add(item.h);
            const text = this.searchText(item.t + ' ' + (wineries.get(this.searchText(item.c).trim()) || ''));
            records.push({ ...item, text, words: this.searchWords(text), isLargeFormat: this.searchLargeFormat(item.v, true) || this.searchLargeFormat(item.n) });
          }
        }
        if (records.length !== first.total || signal.aborted) throw new Error('Incomplete collection index');
        return records;
      }

      async previewCard(handle, base, cache, signal) {
        if (cache.cards.has(handle)) return cache.cards.get(handle).cloneNode(true);
        const root = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
        const url = new URL('products/' + encodeURIComponent(handle), root);
        url.searchParams.set('section_id', 'pellegrini-predictive-product');
        const preview = base.searchParams.get('preview_theme_id') || new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const doc = await this.previewDocument(url, signal);
        const card = doc.querySelector('[data-pg-predictive-product]');
        if (!card || card.dataset.pgPredictiveProduct !== handle) throw new Error('Product preview missing');
        cache.cards.set(handle, card);
        return card.cloneNode(true);
      }

      // Matching helpers below mirror the collection search, including its strict > 1 l rule.
      searchText(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de').replace(/ß/g, 'ss');
      }

      searchWords(text) {
        return Array.from(new Set(text.match(/[\p{L}\p{N}]+/gu) || []));
      }

      searchLargeFormat(value, allowBareLiters = false) {
        // Compare bottle volume, never the total volume of a multi-bottle pack.
        const text = this.searchText(value).trim().replace(/(\d)\s*[x×]\s*(?=\d)/gu, '$1 × ');
        if (allowBareLiters && /^\d+(?:[.,]\d+)?$/.test(text)) return Number(text.replace(',', '.')) > 1;
        const amounts = text.matchAll(/(?:^|[^\p{L}\p{N}.,+\-])(\d+(?:[.,]\d+)?)\s*-?\s*(ml|cl|liter|liters|litres?|ltr\.?|l)(?=$|[^\p{L}\p{N}])/gu);
        for (const amount of amounts) {
          const liters = Number(amount[1].replace(',', '.')) / (amount[2] === 'ml' ? 1000 : amount[2] === 'cl' ? 100 : 1);
          if (liters > 1) return true;
        }
        return false;
      }

      searchTypoDistance(term, word, limit) {
        if (term === word) return 0;
        if (Math.abs(term.length - word.length) > limit) return limit + 1;
        let beforePrevious;
        let previous = Array.from({ length: word.length + 1 }, (_, index) => index);
        for (let row = 1; row <= term.length; row += 1) {
          const current = new Array(word.length + 1).fill(limit + 1);
          current[0] = row;
          let rowMinimum = limit + 1;
          for (let column = Math.max(1, row - limit); column <= Math.min(word.length, row + limit); column += 1) {
            current[column] = Math.min(
              previous[column] + 1,
              current[column - 1] + 1,
              previous[column - 1] + (term[row - 1] === word[column - 1] ? 0 : 1)
            );
            if (row > 1 && column > 1 && term[row - 1] === word[column - 2] && term[row - 2] === word[column - 1]) {
              current[column] = Math.min(current[column], beforePrevious[column - 2] + 1);
            }
            rowMinimum = Math.min(rowMinimum, current[column]);
          }
          if (rowMinimum > limit) return limit + 1;
          beforePrevious = previous;
          previous = current;
        }
        return previous[word.length];
      }

      searchAlternatives(cache, term) {
        const matches = new Set();
        // Keep short codes, article numbers and vintages exact.
        if (!/^\p{L}{4,40}$/u.test(term)) return matches;
        if (!cache.typoVocabulary) {
          cache.makerCodes = new Set(cache.records.map(item => this.searchText(item.c).trim()).filter(Boolean));
          cache.typoVocabulary = new Map();
          for (const item of cache.records) {
            for (const word of item.words) {
              if (!/^\p{L}{4,40}$/u.test(word) || cache.makerCodes.has(word)) continue;
              if (!cache.typoVocabulary.has(word.length)) cache.typoVocabulary.set(word.length, new Set());
              cache.typoVocabulary.get(word.length).add(word);
            }
          }
        }
        if (cache.makerCodes.has(term)) return matches;
        const limit = term.length >= 8 ? 2 : 1;
        for (let length = term.length - limit; length <= term.length + limit; length += 1) {
          for (const word of cache.typoVocabulary.get(length) || []) {
            if (this.searchTypoDistance(term, word, limit) <= limit) matches.add(word);
          }
        }
        return matches;
      }

      searchMatches(cache, terms, bounds) {
        const largeFormat = terms.includes('magnum');
        const textTerms = largeFormat ? terms.filter(term => term !== 'magnum') : terms;
        const records = largeFormat ? cache.records.filter(item => item.isLargeFormat) : cache.records;
        const withinPrice = item => (bounds.min === null || item.p >= bounds.min) && (bounds.max === null || item.p <= bounds.max);
        const exact = records.filter(item => textTerms.every(term => item.text.includes(term)));
        // Only offer typo matches when the selected collection and bottle sizes have no exact text matches.
        if (exact.length || !textTerms.length) return exact.filter(withinPrice);
        const alternatives = textTerms.map(term => this.searchAlternatives(cache, term));
        if (!alternatives.some(words => words.size)) return [];
        return records.filter(item => withinPrice(item) && textTerms.every((term, index) =>
          item.text.includes(term) || item.words.some(word => alternatives[index].has(word))
        ));
      }

      priceBounds(url) {
        const cents = key => {
          const text = url.searchParams.get(key);
          if (text === null || !/^\d+(?:[.,]\d{1,2})?$/.test(text)) return null;
          const value = Math.round(Number(text.replace(',', '.')) * 100);
          return Number.isSafeInteger(value) && value >= 0 ? value : null;
        };
        return { min: cents('pg_price_min'), max: cents('pg_price_max') };
      }



      catalogSearchUrl(query) {
        const collection = new URL(this.dataset.catalogUrl, window.location.origin);
        const current = new URL(window.location.href);
        const sameCollection = current.origin === collection.origin
          && current.pathname.replace(/\/$/, '') === collection.pathname.replace(/\/$/, '');
        const destination = sameCollection ? current : collection;

        destination.searchParams.set('pg_q', query.trim());
        destination.searchParams.delete('q');
        destination.searchParams.delete('page');
        destination.searchParams.delete('section_id');
        destination.hash = 'pellegrini-sortiment-suche';
        return destination.href;
      }

      updateSearchSuggestions(results) {
        const nativeSearch = new URL(this.dataset.searchUrl, window.location.origin);
        for (const link of results.querySelectorAll('a[href]')) {
          const target = new URL(link.href, window.location.origin);
          if (target.origin === nativeSearch.origin
            && target.pathname === nativeSearch.pathname
            && target.searchParams.has('q')) {
            link.href = this.catalogSearchUrl(target.searchParams.get('q'));
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
